// import { DotLottie } from "@lottiefiles/dotlottie-web";
import { DotLottie } from "@lottiefiles/dotlottie-web";
import { observeAndAnimate } from "./utils";
// lotties that play on hover
const hoverLotties = document.querySelectorAll(".hover-lottie");
hoverLotties.forEach((hoverLottie) => {
  const animation = new DotLottie({
    autoplay: false,
    loop: false,
    // speed: 0.5,
    canvas: hoverLottie,
    src: `/wp-content/themes/codis-wp-starter/public/lottie/${hoverLottie.dataset.lottie}.lottie`,
  });
  const parent = hoverLottie.parentNode;

  parent.addEventListener("mouseenter", () => {
    animation.setMode("forward");
    animation.play();
  });

  parent.addEventListener("mouseleave", () => {
    animation.setMode("reverse");
    animation.play();
  });
});

// lotties that play once 
const onceLotties = document.querySelectorAll(".once-lottie");
onceLotties.forEach((onceLottie) => {
  const animation = new DotLottie({
    autoplay: false,
    loop: false,
    canvas: onceLottie,
    src: `/wp-content/themes/codis-wp-starter/public/lottie/${onceLottie.dataset.lottie}.lottie`,
  });

  observeAndAnimate(onceLottie.parentNode, () => {
    console.log('oncelottie observed')
    animation.play();
  });

});

// lotties that play automatically
const autoLotties = document.querySelectorAll(".auto-lottie");
autoLotties.forEach((autoLottie) => {
  console.log('autolottie found')
  const animation = new DotLottie({
    autoplay: true,
    loop: true,
    canvas: autoLottie,
    src: `/wp-content/themes/codis-wp-starter/public/lottie/${autoLottie.dataset.lottie}.lottie`,
  });
});
